
import React from "react";

interface LeadStatusProps {
  status: string;
}

export const LeadStatus = ({ status }: LeadStatusProps) => {
  const getStatusEmoticon = (status: string) => {
    switch (status) {
      case "cold":
        return "🧊";
      case "warm":
        return "🔆";
      case "hot":
        return "🔥";
      default:
        return "";
    }
  };

  return (
    <span
      className={`inline-flex px-2 py-1 text-xs rounded-full font-medium
        ${
          status === "cold"
            ? "bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300"
            : status === "warm"
            ? "bg-green-100 dark:bg-green-900/50 text-green-700 dark:text-green-300"
            : "bg-red-100 dark:bg-red-900/50 text-red-700 dark:text-red-300"
        }
      `}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)} {getStatusEmoticon(status)}
    </span>
  );
};
